import { IListUser } from 'src/redux/slices/users';

export type IChequeTableFilterValue = string | Date;

export type IChequeTableFilters = {
  generalSearch: string;
  receivedVia: string | null;
  chequeDate: Date | null;
  bank: string | null;
  startDate: Date | null;
  endDate: Date | null;
  receivedDate: Date | null;
  type: string | null;
  paidDate: Date | null;
};

export type IChequeTableSort = {
  sortBy: string;
  order: 'asc' | 'desc';
};

export enum ChequeStatus {
  IN_HAND = 'In Hand',
  PAID = 'Paid',
  RETURN = 'Return',
  SETTLED = 'Settled',
  HANDOVER = 'Handover',
  RECOVERED = 'Recovered',
}

export enum ChequeCustomerType {
  SALE = 'sale',
  WHOLESALE = 'wholesale',
}

export const CHEQUE_STATUS_OPTIONS = [
  { value: ChequeStatus.IN_HAND, label: 'In Hand' },
  { value: ChequeStatus.PAID, label: 'Paid' },
  { value: ChequeStatus.RETURN, label: 'Return' },
  { value: ChequeStatus.SETTLED, label: 'Settled' },
  { value: ChequeStatus.HANDOVER, label: 'Handover' },
  { value: ChequeStatus.RECOVERED, label: 'Recovered' },
];

export interface IChequeListItem {
  _id: string;
  customer: string;
  receivedVia: string;
  holder: string;
  chequeNumber: string;
  chequeDate: string;
  receivedDate: string;
  amountInCents: number;
  bank: string;
  status: ChequeStatus;
  createdAt: string;
  paidHistory?: IChequeItemHistory[];
}

export interface IChequeItemHistory {
  _id: string;
  holder: string;
  date: string;
  status: ChequeStatus;
  createdBy: IListUser;
  updatedBy: IListUser;
  createdAt: string;
  updatedAt: string;
}

export interface IChequeItem {
  _id: string;
  customer: string;
  invoice: string | null;
  receivedVia: string;
  chequeNumber: string;
  chequeDate: string;
  receivedDate: string;
  amountInCents: number;
  bank: string;
  holder: string;
  status: ChequeStatus;
  type: ChequeCustomerType;
  history: IChequeItemHistory[];
  createdBy: IListUser;
  updatedBy: IListUser;
  createdAt: string;
  updatedAt: string;
}

export interface IChequeReceived {
  receivedVia: string;
}
